import { regionaisKeys } from '@/features/regionais/utils/queries'
import { usePrefetch } from '@/hooks/use-prefetch'
import { GetUnidadeDeNegocioService } from '@/http/unidade-negocio.service'

export const usePrefetchRegionais = () => {
  return usePrefetch({
    queryKey: regionaisKeys.listas(),
    queryFn: () => new GetUnidadeDeNegocioService().execute().then((response) => response.data),
    staleTime: 60 * 1000 * 5,
  })
}
